const teamInfo = {
    byId: {
        108: "angels",
        117: "astros",
        133: "athletics",
        141: "bluejays",
        144: "braves",
        158: "brewers",
        138: "cardinals",
        112: "cubs",
        109: "dbacks",
        119: "dodgers",
        137: "giants",
        114: "guardians",
        136: "mariners",
        146: "marlins",
        121: "mets",
        120: "nationals",
        110: "orioles",
        135: "padres",
        143: "phillies",
        134: "pirates",
        140: "rangers",
        139: "rays",
        113: "reds",
        111: "redsox",
        115: "rockies",
        118: "royals",
        116: "tigers",
        142: "twins",
        145: "whitesox",
        147: "yankees",
    },
    bySlug: {
        angels: 108,
        astros: 117,
        athletics: 133,
        bluejays: 141,
        braves: 144,
        brewers: 158,
        cardinals: 138,
        cubs: 112,
        dbacks: 109,
        dodgers: 119,
        giants: 137,
        guardians: 114,
        indians: 114,
        mariners: 136,
        marlins: 146,
        mets: 121,
        nationals: 120,
        orioles: 110,
        padres: 135,
        phillies: 143,
        pirates: 134,
        rangers: 140,
        rays: 139,
        reds: 113,
        redsox: 111,
        rockies: 115,
        royals: 118,
        tigers: 116,
        twins: 142,
        whitesox: 145,
        yankees: 147,
    },
};
export const getTeamIdBySlug = (slug) => teamInfo.bySlug[slug] || null;
export const getTeamSlugById = (id) => teamInfo.byId[id] || null;
